import { __decorate } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import isString from 'lodash/isString';
import noop from 'lodash/noop';
import { getConfig, getProPrefixCls } from 'choerodon-ui/lib/configure';
import C7NRate from 'choerodon-ui/lib/rate';
import { getTooltipTheme } from 'choerodon-ui/lib/_util/TooltipUtils';
import { Tooltip as TextTooltip } from '../core/enum';
import { FIELD_SUFFIX } from '../form/utils';
import { FormField } from '../field/FormField';
import { renderValidationMessage } from '../field/utils';
import Icon from '../icon';
import { LabelLayout, ShowValidation } from '../form/enum';
import autobind from '../_util/autobind';
import { hide, show } from '../tooltip/singleton';
export class Rate extends FormField {
    constructor() {
        super(...arguments);
        this.onChange = (value) => {
            this.setValue(value);
        };
    }
    get hasFloatLabel() {
        const { labelLayout } = this;
        return [LabelLayout.float, LabelLayout.placeholder].includes(labelLayout);
    }
    renderValidationResult(validationResult) {
        const validationMessage = this.getValidationMessage(validationResult);
        const { labelLayout, showValidation } = this.context;
        if (validationMessage) {
            const showIcon = !([LabelLayout.float, LabelLayout.placeholder].includes(labelLayout) || showValidation === ShowValidation.newLine);
            return renderValidationMessage(validationMessage, showIcon);
        }
    }
    handleHelpMouseEnter(e) {
        show(e.currentTarget, {
            title: this.getProp('help'),
            popupClassName: `${getConfig('proPrefixCls')}-tooltip-popup-help`,
            theme: getTooltipTheme('help'),
        });
    }
    handleHelpMouseLeave() {
        hide();
    }
    renderTooltipHelp() {
        const help = this.getProp('help');
        if (help) {
            return (React.createElement(Icon, { type: "help", onMouseEnter: this.handleHelpMouseEnter, onMouseLeave: this.handleHelpMouseLeave }));
        }
    }
    renderFloatLabel() {
        if (this.hasFloatLabel) {
            const label = this.getLabel();
            if (label) {
                const { labelTooltip, floatLabelOffsetX } = this;
                const prefixCls = getProPrefixCls(FIELD_SUFFIX);
                const required = this.getProp('required');
                const classString = classNames(`${prefixCls}-label`, {
                    [`${prefixCls}-required`]: required,
                    [`${prefixCls}-readonly`]: this.readOnly,
                });
                const style = floatLabelOffsetX ? {
                    marginLeft: floatLabelOffsetX,
                } : undefined;
                return (React.createElement("div", { className: `${prefixCls}-label-wrapper`, style: style },
                    React.createElement("div", { className: classString, title: isString(label) && ![TextTooltip.always, TextTooltip.overflow].includes(labelTooltip) ? label : undefined, onMouseEnter: this.handleFloatLabelMouseEnter, onMouseLeave: this.handleFloatLabelMouseLeave }, label),
                    this.renderTooltipHelp()));
            }
        }
    }
    getOtherProps() {
        const otherProps = super.getOtherProps();
        otherProps.onFocus = noop;
        otherProps.onBlur = noop;
        return otherProps;
    }
    renderWrapper() {
        const value = this.getValue();
        return (React.createElement("label", Object.assign({ key: "wrapper" }, this.getWrapperProps()),
            this.renderFloatLabel(),
            React.createElement("div", { onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave },
                React.createElement(C7NRate, Object.assign({}, this.getOtherProps(), { onChange: this.onChange, value: value })))));
    }
    renderHelpMessage() {
        const label = this.getLabel();
        if (!this.hasFloatLabel || !label) {
            const help = this.getProp('help');
            if (help) {
                return (React.createElement("div", { key: "help", className: `${getProPrefixCls(FIELD_SUFFIX)}-help` }, help));
            }
        }
    }
}
Rate.displayName = 'Rate';
Rate.propTypes = {
    ...C7NRate.propTypes,
    ...FormField.propTypes,
};
Rate.defaultProps = {
    ...C7NRate.defaultProps,
    ...FormField.defaultProps,
    suffixCls: 'rate',
};
// eslint-disable-next-line camelcase
Rate.__PRO_RATE = true;
// eslint-disable-next-line camelcase
Rate.__IS_IN_CELL_EDITOR = true;
__decorate([
    autobind
], Rate.prototype, "renderValidationResult", null);
__decorate([
    autobind
], Rate.prototype, "handleHelpMouseEnter", null);
let ObserverRate = class ObserverRate extends Rate {
};
ObserverRate.defaultProps = Rate.defaultProps;
// eslint-disable-next-line camelcase
ObserverRate.__PRO_RATE = true;
// eslint-disable-next-line camelcase
ObserverRate.__IS_IN_CELL_EDITOR = true;
ObserverRate = __decorate([
    observer
], ObserverRate);
export default ObserverRate;
